import { Tab, TabPanel, Tabs } from 'react-tabs'
import { useAppDispatch, useAppSelector } from '../../hooks'
import ItemPanel from '../ItemPanel/ItemPanel'
import * as Styled from '../styles'
import { setSelectedToolbarDoorSubTab } from '../../store/ui/uiSlice'

export default function GaragePanel() {
  const dispatch = useAppDispatch()
  const { content } = useAppSelector((state) => state.init)
  const { selectedToolbarDoorSubTab } = useAppSelector((state) => state.ui) || {}

  return (
    <Tabs
      selectedIndex={selectedToolbarDoorSubTab}
      onSelect={(index) => {
        dispatch(setSelectedToolbarDoorSubTab(index))
      }}
    >
      <Styled.SubTabsList>
        <Tab tabIndex="0">{content?.items?.doors?.title}</Tab>
        <Tab tabIndex="1">{content?.items?.doubleDoors?.title}</Tab>
      </Styled.SubTabsList>
      <TabPanel>
        <ItemPanel itemType="doors" />
      </TabPanel>
      <TabPanel>
        <ItemPanel itemType="doubleDoors" />
      </TabPanel>
    </Tabs>
  )
}
